'use client';

import BasicValuePropsList from '../BasicValuePropsList';
import PremiumValuePropsList from '../PremiumValuePropsList';
import type { ValueProp } from '../ValuePropsList';
import styles from './styles.module.css';

export type ComparisonValuePropsListProps = {
	/**
	 * @defaultValue
	 * ```tsx
	 * "sisu-comparison-value-props-list"
	 * ```
	 */
	'data-testid'?: string;

	/**
	 * @defaultValue
	 * ```tsx
	 * []
	 * ```
	 */
	basicValueProps?: ValueProp[];
	premiumValueProps?: ValueProp[];
};

export default function ComparisonValuePropsList({
	'data-testid': testId = 'sisu-comparison-value-props-list',
	basicValueProps = [],
	premiumValueProps = [],
}: ComparisonValuePropsListProps) {
	return (
		<div className={styles.container} data-testid={testId}>
			<BasicValuePropsList valueProps={basicValueProps} />
			<PremiumValuePropsList valueProps={premiumValueProps} />
		</div>
	);
}
